import { z } from 'zod';
export const GeneratePreviewRequestSchema = z.object({
    image: z.string().optional(),
    gcsUri: z.string().url().optional(),
    themeId: z.string().optional(),
    theme_id: z.string().optional()
}).refine(data => data.image || data.gcsUri, {
    message: "Either image or gcsUri must be provided"
});
export const AnalyzeFaceRequestSchema = z.object({
    image: z.string().min(1, "Image is required"),
    themeId: z.string().optional(),
    theme_id: z.string().optional()
});
export const CollageRequestSchema = z.object({
    image: z.string().optional(),
    gcs_uri: z.string().url().optional(),
    matched_animal: z.string().min(1, "matched_animal is required"),
    themeId: z.string().optional(),
    theme_id: z.string().optional()
}).refine(data => data.image || data.gcs_uri, {
    message: "Either image or gcs_uri must be provided"
});
export const AdminThemeUpdateSchema = z.object({
    themeId: z.string().optional(),
    brand: z.any().optional(),
    colors: z.any().optional(),
    prompts: z.any().optional(),
    _source: z.any().optional()
}).catchall(z.any()); // Allowed flexibility for theme configs for now, could be strict
export const StripeCheckoutRequestSchema = z.object({
    priceId: z.string().min(1, "priceId is required")
});
